import React from 'react';
import { useId } from '@floating-ui/react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../atoms/Modal';
import { DEFAULT_APPEAL_SET_CONFIGURATION } from '../SocialLinks';
import * as Styled from './ShareButton.styled';
import { ShareButtonModal } from './ShareButtonModal';
import { IosShare } from '../../svgs';
import { StyledContentContainer } from '../../containers/StyledContentContainer.styled';
import { setColorWithOpacityCss } from '../../utils/setColorWithOpacityCss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The `ShareButton` content block provides a button that displays a modal allowing users to share a
 * campaign on various social media platforms.
 */
export const ShareButton = _ref => {
  let {
    alignXPreset,
    cssBorderColor,
    cssBorderWidth,
    cssBorderRadius,
    cssBackgroundColor,
    cssColor,
    cssBackgroundColorOpacity,
    heading = '',
    isInstagramSharingEnabled = false,
    isMobileOrTablet = false,
    subheading = '',
    appealSet = DEFAULT_APPEAL_SET_CONFIGURATION,
    openLinksInNewTab = true,
    parentLayoutInfo,
    socialShareLinks,
    videoPreview,
    ...rest
  } = _ref;
  const [isOpen, setIsOpen] = React.useState(false);
  const {
    t
  } = useTranslation('blocks.shareButton');
  const ariaLabelledById = useId();
  return /*#__PURE__*/_jsx(StyledContentContainer, {
    "data-id": "cp-share-button",
    parentLayoutInfo: parentLayoutInfo,
    children: /*#__PURE__*/_jsx(Modal, {
      isOpen: isOpen,
      setIsOpen: setIsOpen,
      closeButtonLabel: t('ShareButton.closeButtonLabel', 'Close share options'),
      ariaLabelledById: ariaLabelledById,
      renderTrigger: referenceProps => /*#__PURE__*/_jsxs(Styled.ShareButtonElement, {
        alignXPreset: alignXPreset,
        cssBorderWidth: cssBorderWidth,
        cssBorderColor: cssBorderColor,
        cssBackgroundColor: setColorWithOpacityCss(cssBackgroundColor, cssBackgroundColorOpacity),
        cssBorderRadius: cssBorderRadius,
        cssColor: cssColor,
        "data-id": "cp-share-button-open",
        ...rest,
        ...referenceProps,
        children: [/*#__PURE__*/_jsx(IosShare, {
          fill: "currentcolor"
        }), /*#__PURE__*/_jsx("span", {
          children: t('ShareButton.share', 'Share')
        })]
      }),
      children: /*#__PURE__*/_jsx(ShareButtonModal, {
        appealSet: appealSet,
        ariaLabelledById: ariaLabelledById,
        cssBorderWidth: cssBorderWidth,
        cssBorderColor: cssBorderColor,
        cssBackgroundColor: cssBackgroundColor,
        cssBackgroundColorOpacity: cssBackgroundColorOpacity,
        cssBorderRadius: cssBorderRadius,
        cssColor: cssColor,
        heading: heading,
        isInstagramSharingEnabled: isInstagramSharingEnabled,
        isMobileOrTablet: isMobileOrTablet,
        openLinksInNewTab: openLinksInNewTab,
        subheading: subheading,
        socialShareLinks: socialShareLinks,
        videoPreview: videoPreview
      })
    })
  });
};